module.exports = __webpack_public_path__ + "img/svg.a20d9369.svg";